import { Component, OnInit } from "@angular/core";

import { ErrorService } from "./error.service";
import {Message} from 'primeng/primeng';

@Component({
    selector: 'oa-error',
    template: `
        <p-growl [value]="msgs"></p-growl>
    `
})
export class ErrorComponent implements OnInit {

    msgs: Message[] = [];

    constructor (private _errorService: ErrorService) {}

    ngOnInit() {
        this._errorService.showNotification.subscribe(
          errorData => {
              this.msgs.push(errorData);
          }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/common/errors/error.component.ts